import { useSelector } from 'react-redux';
import { EName } from '../../../repositories/price-estimator/entities/filter/FilterSchema';

import { selectMyHomeId } from '../../../selectors/page';
import { selectPreciseFiltersContent } from '../../../selectors/preciseFilters';
import {
  EPreciseFilterValues,
  IFilterOption,
  IPreciseFilter,
  IPreciseFiltersData,
} from '../../../types/redux/preciseFilters';

function filteredPreciseFiltersForMyHome(data: IPreciseFiltersData) {
  // на этом моменте filter точно будет в data
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const myHomeFilters = data.filters
    .map(item => {
      if (item.name === EName.Entrance) {
        return null;
      }

      if (item.name === EName.Amenities) {
        item.options = item.options
          .map(option => {
            if (option.name === EPreciseFilterValues.KitchenFurniture) {
              return null;
            }

            return option;
          })
          .filter(option => option) as IFilterOption[];
      }

      return item;
    })
    .filter(item => item) as IPreciseFilter[];

  return {
    ...data,
    filters: myHomeFilters,
  };
}

export function usePreciseFilters() {
  const preciseFiltersData = useSelector(selectPreciseFiltersContent);
  const myHomeId = useSelector(selectMyHomeId);

  if (!preciseFiltersData) {
    return null;
  }

  return myHomeId ? filteredPreciseFiltersForMyHome(preciseFiltersData) : preciseFiltersData;
}
